// Copyright 1999-2024. WebPros International GmbH. All rights reserved.

export const isProduction = () => process.env.NODE_ENV === 'production';
export const isTesting = () => process.env.NODE_ENV === 'test';
export const isAdminSite = () => window.location.pathname.includes('admin');

export const pathTo = (path: string) => `${isAdminSite() ? '/admin' : ''}/${path}`;
export const pathToHome = () => pathTo('');
